import type { Routes } from '@angular/router';

export const RESTAURANTS_LIST_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/restaurants/layouts/restaurant-list-layout/restaurant-list-layout.component').then(
                (m) => m.RestaurantListLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                loadComponent: () =>
                    import('#modules/restaurants/views/restaurants/restaurants.component').then((m) => m.RestaurantsComponent),
            },
        ],
    },
];
